import { render, staticRenderFns } from "./IconChartPieOutline.vue?vue&type=template&id=4fabc3d4"
import script from "./IconChartPieOutline.vue?vue&type=script&lang=js"
export * from "./IconChartPieOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports